module.exports = __webpack_public_path__ + "static/img/logo.0efd70ae.png";